import Vue from 'vue'
import ActionCableVue from 'actioncable-vue'

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: `${process.env.VUE_APP_API_URL}/realtime`,
  connectImmediately: false,
})
